const config = {
  apiGateway: {
    REGION: 'us-west-2',
    INTERNAL_API_URL: 'https://kybxa8ikm7.execute-api.us-west-2.amazonaws.com/prod',
    COMPANY_API_URL: 'https://mqfvsp42gl.execute-api.us-west-2.amazonaws.com/prod'
  },
  reactApp: {
    VERSION: 'taxonomy-company-1.13.4',
    HOSTNAME: 'https://company.staging.evolution.forwoodsafety.com'
  },
  configurationService: {
    URL: 'https://config.staging.evolution.forwoodsafety.com',
    WEBSOCKET: 'wss://gyaxuutzbl.execute-api.us-west-2.amazonaws.com/staging'
  },
};

export default config;